export default "__VITE_ASSET__DQGmvEHe__"